import { Controller } from "@hotwired/stimulus"

/**
 * EntityPreviewController - mantiene una vista previa en vivo de un equipo o
 * competición mientras se edita el formulario: refleja el nombre escrito y el
 * escudo/logo seleccionado tal como aparecerán en el listado.
 * Se conecta con data-controller="entity-preview".
 *
 * Targets: nameInput, nameOutput, image, placeholder, fileInput, remove.
 * Values: placeholder (texto por defecto cuando el nombre está vacío).
 */
export default class extends Controller {
  static targets = ["nameInput", "nameOutput", "image", "placeholder", "fileInput", "remove"]
  static values = { placeholder: String }

  connect() {
    this.syncName()
  }

  // Copia el nombre escrito a la vista previa (o el texto por defecto si está vacío).
  syncName() {
    const name = this.hasNameInputTarget ? this.nameInputTarget.value.trim() : ""
    this.nameOutputTarget.textContent = name || this.placeholderValue
    this.nameOutputTarget.classList.toggle("is-empty", !name)
  }

  // Previsualiza el archivo recién seleccionado y cancela cualquier eliminación pendiente.
  previewImage() {
    const file = this.fileInputTarget.files?.[0]
    if (!file) return

    this.#showImage(URL.createObjectURL(file))
    if (this.hasRemoveTarget) this.removeTarget.value = "0"
  }

  // Limpia el campo y marca el adjunto existente para eliminarlo al guardar.
  removeImage() {
    this.fileInputTarget.value = ""
    if (this.hasRemoveTarget) this.removeTarget.value = "1"
    this.#hideImage()
  }

  #showImage(src) {
    this.imageTarget.src = src
    this.imageTarget.classList.remove("d-none")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("d-none")
  }

  #hideImage() {
    this.imageTarget.removeAttribute("src")
    this.imageTarget.classList.add("d-none")
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.remove("d-none")
  }
}
